import React, { PureComponent } from "react";
import axios from "axios";
import moment from "moment";
import { Button, FormGroup, Container, Row, Col } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

moment.locale("es");

const BASE_URL = "https://us-central1-escuelapp-5f754.cloudfunctions.net/";

const BASE_URL_V2_PRODUCTION =
  "https://escuelapp-api-v2.azurewebsites.net/api/";

class Checkout extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      user_id: "",
      loading: true,
      waiting: false,
      error: false,
      alreadySubscribed: false,
      canFillForm: false,
    };

    this.getContent = this.getContent.bind(this);
    this.checkIsSubscribed = this.checkIsSubscribed.bind(this);
    this.goToCheckOut = this.goToCheckOut.bind(this);
    this.setFormData = this.setFormData.bind(this);
    this.processForm = this.processForm.bind(this);
  }

  async processForm() {
    //console.log(this.state.data);

    this.setState({ waiting: true });

    var finalData = {};
    finalData.address = {};
    finalData.address.line1 = this.state.data.line1;
    finalData.address.line2 = this.state.data.line2 || "";
    finalData.address.city = this.state.data.city;
    finalData.address.country = this.state.data.country;
    finalData.address.postal_code = this.state.data.postal_code;
    finalData.address.state = this.state.data.state;
    finalData.email = this.state.data.email;
    finalData.name = this.state.data.name;
    finalData.phone = this.state.data.phone;

    //"tax_id_data": [{"type":"es_cif", "value":"B90078874"}]

    finalData.tax_id_data = [];

    finalData.tax_id_data.push({
      type: "es_cif",
      value: this.state.data.es_cif,
    });

    const resultUser = await axios.post(
      `${BASE_URL}createCustomer`,
      finalData,
      { crossDomain: true }
    );

    if (resultUser.data) {
      //console.log("USUARIO CREADO", resultUser.data);

      var dataCheckout = {};
      dataCheckout.email = this.state.data.email;
      dataCheckout.customer = resultUser.data.id;

      this.goToCheckOut(dataCheckout);
    }
  }

  checkIsSubscribed(userId) {
    return new Promise((resolve, reject) => {
      const AuthStr = "Bearer jqkoUdxyfcLMpKAFpPQcxrGMUHDZiBiZ";

      axios
        .get(`https://api.revenuecat.com/v1/subscribers/${userId}`, {
          crossDomain: true,
          headers: { Authorization: AuthStr },
        })
        .then((result) => {
          if (result.status === 200) {
            const subscription =
              Object.keys(result.data.subscriber.entitlements).length > 0;

            if (subscription) {
              const expires =
                result.data.subscriber.entitlements.subscribed.expires_date;
              const created =
                result.data.subscriber.entitlements.subscribed.purchase_date;

              var now = new moment();
              var expire = moment(expires);
              var creation = moment(created);

              if (now.isBetween(creation, expire)) {
                resolve(true);
              } else {
                resolve(false);
              }
            } else {
              resolve(false);
            }
          } else {
            resolve(false);
          }
        })
        .catch((err) => {
          //console.log(err);
          resolve(false);
        });
    });
  }

  setFormData(event) {
    //console.log(event.target.value);
    let value = event.target.value;

    let edited = this.state.data;
    edited[event.target.name] = value;
    this.setState({ data: edited });
  }

  async componentDidMount() {
    var where = this.props.location.search;
    var param = where.substr(where.indexOf("=") + 1);

    this.setState({ user_id: param, loading: true });

    //OBTENEMOS EMAIL DEL USUARIO POR UID

    const resultUser = await axios.get(
      `${BASE_URL_V2_PRODUCTION}accounts/getbyuid/${id}`
    );

    if (resultUser.data) {
      const result = await this.checkIsSubscribed(resultUser.data.uid);

      if (result) {
        //YA ESTABA SUSCRITO
        this.setState({ loading: false, alreadySubscribed: true });
      } //PROCEDEMOS A PAGAR
      else {
        var aux = this.state.data;
        aux.email = user.email;

        //console.log(aux.email);

        //this.goToCheckOut(data);
        this.setState({ loading: false, canFillForm: true, data: aux });
      }

      //console.log("SUSCRIPCION", result);
    }
  }

  async goToCheckOut(data) {
    data.selectedProc;

    const resultSession = await axios.post(
      `${BASE_URL}createPayment`,
      { data },
      { crossDomain: true }
    );

    if (resultSession) {
      const sessionId = resultSession.data.id;

      //console.log(sessionId);

      const testKey = "pk_test_AWIi7aMrX3qbdQpr57wsueei00a5vIzcXR";
      const productionKey = "pk_live_JqMlcV5hos6at5MY5SsvfAM200552ZQFUt";
      var stripe = Stripe(productionKey);

      const resultCheckOut = await stripe.redirectToCheckout({
        sessionId: sessionId,
      });

      if (resultCheckOut) {
        //console.log(result);
      }
    }
  }

  getContent() {
    if (!this.state.loading && this.state.canFillForm) {
      return (
        <div className="col-lg-4 col-sm-8 col-md-4 col-xl-4">
          <div className="card">
            <div>
              <div>
                <Container className="themed-container">
                  <Row md={4}>
                    <Col>
                      <div style={{ textAlign: "center", marginTop: "50px" }}>
                        <img
                          src="https://escuelapp.firebaseapp.com/assets/images/logo_header.png"
                          style={{ width: "80%" }}
                        ></img>
                      </div>
                    </Col>
                  </Row>
                  <div style={{ padding: "20px" }}>
                    <div style={{ textAlign: "center" }}>
                      <p>Bienvenid@ al proceso de suscripción de Escuelapp</p>
                      <p>Por favor, rellene los datos de facturación:</p>
                    </div>

                    <AvForm onSubmit={this.processForm}>
                      <Row form>
                        <Col md={8}>
                          <FormGroup>
                            <AvField
                              name="name"
                              label="Nombre / Empresa"
                              type="text"
                              onChange={this.setFormData}
                              errorMessage="* Este campo es obligatorio"
                              validate={{
                                required: { value: true },
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col md={4}>
                          <FormGroup>
                            <AvField
                              name="es_cif"
                              label="DNI / CIF"
                              type="text"
                              onChange={this.setFormData}
                              errorMessage="* Este campo es obligatorio"
                              validate={{
                                required: { value: true },
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row form>
                        <Col md={12}>
                          <FormGroup>
                            <AvField
                              name="line1"
                              label="Dirección"
                              type="text"
                              onChange={this.setFormData}
                              errorMessage="* Este campo es obligatorio"
                              validate={{
                                required: { value: true },
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row form>
                        <Col md={9}>
                          <FormGroup>
                            <AvField
                              name="line2"
                              label="Dirección línea 2"
                              type="text"
                              onChange={this.setFormData}
                              errorMessage="* Este campo es obligatorio"
                              validate={{
                                required: { value: false },
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col md={3}>
                          <FormGroup>
                            <AvField
                              name="postal_code"
                              label="Código Postal"
                              type="text"
                              onChange={this.setFormData}
                              errorMessage="* Este campo es obligatorio"
                              validate={{
                                required: { value: true },
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row form>
                        <Col md={4}>
                          <FormGroup>
                            <AvField
                              name="city"
                              label="Ciudad"
                              type="text"
                              onChange={this.setFormData}
                              errorMessage="* Este campo es obligatorio"
                              validate={{
                                required: { value: true },
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <AvField
                              name="state"
                              label="Provincia / Estado"
                              type="text"
                              onChange={this.setFormData}
                              errorMessage="* Este campo es obligatorio"
                              validate={{
                                required: { value: true },
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <AvField
                              name="country"
                              label="Pais"
                              type="text"
                              onChange={this.setFormData}
                              errorMessage="* Este campo es obligatorio"
                              validate={{
                                required: { value: true },
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row form>
                        <Col md={4}>
                          <FormGroup>
                            <AvField
                              name="phone"
                              label="Teléfono"
                              type="text"
                              onChange={this.setFormData}
                              errorMessage="* Este campo es obligatorio"
                              validate={{
                                required: { value: true },
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row style={{ textAlign: "center" }}>
                        <Col md={12}>
                          <Button disabled={this.state.waiting} color="primary">
                            {this.state.waiting
                              ? "Un momento por favor..."
                              : "Proceder al Pre-Pago"}
                          </Button>
                        </Col>
                      </Row>
                    </AvForm>
                  </div>
                </Container>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (this.state.loading && !this.state.error) {
      return (
        <div className="page-error-container animated slideInUpTiny animation-duration-3">
          <div className="page-error-content">
            <div className="error-code mb-4 animated zoomInDown">
              <img src="assets/images/Target-128.png" />
            </div>
            <h2 className="text-center fw-regular title animated bounceIn animation-delay-10">
              Cargando...
            </h2>

            <p className="text-center animated flipInX animation-delay-20"></p>
          </div>
        </div>
      );
    } else if (this.state.error) {
      return (
        <div className="page-error-container animated slideInUpTiny animation-duration-3">
          <div className="page-error-content">
            <div className="error-code mb-4 animated zoomInDown">
              <img src="assets/images/error.png" />
            </div>
            <h2 className="text-center fw-regular title animated bounceIn animation-delay-10">
              Ha ocurrido un error, por favor, vuelve a intentarlo
            </h2>

            <p className="text-center animated flipInX animation-delay-20"></p>
          </div>
        </div>
      );
    } else if (this.state.alreadySubscribed) {
      return (
        <div className="page-error-container animated slideInUpTiny animation-duration-3">
          <div className="page-error-content">
            <div className="error-code mb-4 animated zoomInDown">
              <img src="assets/images/Thumbs-Up-128.png" />
            </div>
            <h2 className="text-center fw-regular title animated bounceIn animation-delay-10">
              Este usuario ya tiene una suscripción activa, no se ha procedido
              con el pago.
            </h2>

            <p className="text-center animated flipInX animation-delay-20"></p>
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        {this.getContent()}
      </div>
    );
  }
}

export default Checkout;



// WEBPACK FOOTER //
// ./app/routes/extraPages/routes/checkout/index.js